import bankRabobank from '../../banksPNG/bankRabobank.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}
export const BancoRabobankIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco Rabo',
}: IconProps) => <img src={bankRabobank} width={width} height={height} alt={alt} />;
